import type { CSSProperties } from "react";
import { cssClass } from "./constant";

export type OddImageOutStylesType = {
  outerDiv: CSSProperties;
  imageContainer: CSSProperties;
};

export const OddImageOutStyles: OddImageOutStylesType = {
  outerDiv: {
    ...cssClass.outerDiv,
    flexDirection: "row",
    gap: "2%",
  },

  imageContainer: {
    ...cssClass.choiceCard,
    borderRadius: "10%",
  },
};
